export default __webpack_public_path__ + "static/media/higher_icon_padlock_reversed.152168c1.svg";